module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "track-card dflex",
    class: {
      playing: _vm.isPlaying
    }
  }, [(!_vm.isEmptyAlbum) ? _c('v-flex', {
    staticClass: "track-info",
    attrs: {
      "xs12": "",
      "pa-0": ""
    },
    on: {
      "mouseenter": function($event) {
        _vm.is_component_hover = true
      },
      "mouseleave": function($event) {
        _vm.is_component_hover = false
      }
    }
  }, [_c('v-flex', {
    staticClass: "track-cover px-0 py-0",
    attrs: {
      "xs12": ""
    }
  }, [(_vm.item.album_type == 'playlist') ? [_c('div', {
    staticClass: "playlist-icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/playlist.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "track-image",
    class: _vm.item.album_type,
    style: ({
      'background-image': ("url(" + _vm.album1Cover + "), url(" + _vm.album2Cover + "), url(" + _vm.album3Cover + "), url(" + _vm.album4Cover + ")"),
    })
  })] : [_c('div', {
    staticClass: "track-image",
    style: ({
      'background-image': 'url(' + _vm.item.cover.url + ')'
    })
  })], _vm._v(" "), (_vm.forCollection) ? _c('v-flex', {
    staticClass: "track-actions forCollection",
    attrs: {
      "xs12": ""
    }
  }, [(!_vm.isPlaying || _vm.$store.state.player.isPaused) ? _c('span', {
    staticClass: "collection-counter"
  }, [_vm._v(_vm._s(_vm.objectIndex + 1))]) : _vm._e(), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        _vm.gotoItem()
      }
    }
  }, [_c('v-flex', {
    staticClass: "touch-flex",
    attrs: {
      "xs12": ""
    }
  })], 1), _vm._v(" "), (!_vm.isPlaying || _vm.$store.state.player.isPaused) ? _c('v-btn', {
    staticClass: "play-button",
    class: {
      'play-button-2': _vm.playButton2
    },
    nativeOn: {
      "click": function($event) {
        _vm.playSong()
      }
    }
  }, [_c('v-icon', {
    class: [{
      'play-button-2': _vm.playButton2,
      iconHasWhiteBG: _vm.playButton2IconHasWhiteBG,
      'black--text': _vm.playButton2IconHasWhiteBG,
    } ]
  }, [_vm._v("\n\t\t\t\t\t\t\tplay_arrow\n\t\t\t\t\t\t")])], 1) : _vm._e(), _vm._v(" "), (_vm.isPlaying && !_vm.$store.state.player.isPaused) ? _c('v-btn', {
    staticClass: "play-button",
    nativeOn: {
      "click": function($event) {
        _vm.pauseSong()
      }
    }
  }, [_c('v-icon', {
    class: [{
      'play-button-2': _vm.playButton2,
      iconHasWhiteBG: _vm.playButton2IconHasWhiteBG,
      'black--text': _vm.playButton2IconHasWhiteBG,
    }]
  }, [_vm._v("\n\t\t\t\t\t\t\tpause\n\t\t\t\t\t\t")])], 1) : _vm._e(), _vm._v(" "), (_vm.currentUser && _vm.willMenuRender && !_vm.hideMoreMenu) ? _c('v-menu', {
    staticClass: "track-menu",
    attrs: {
      "offset-y": "",
      "close-on-content-click": false,
      "nudge-width": 100
    },
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.is_menu_hover = true
      }
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("more_horiz")])], 1), _vm._v(" "), _c('v-card', [_c('v-list', [(_vm.currentUser.user_type == 'label') ? _c('v-list-tile', {
    key: "add_to_my_label",
    staticClass: "default-menu-item track-menu-item",
    nativeOn: {
      "click": function($event) {
        _vm.addToMyLabel()
      }
    }
  }, [_c('v-list-tile-title', [_c('label', [_vm._v("Add to my label")])])], 1) : _vm._e(), _vm._v(" "), (false && _vm.item.album_type != 'playlist') ? _c('v-list-tile', {
    key: "add_to_playlist",
    staticClass: "default-menu-item track-menu-item has-sub-menu"
  }, [_c('v-menu', {
    staticClass: "track-menu",
    attrs: {
      "offset-x": ""
    },
    model: {
      value: (_vm.submenu),
      callback: function($$v) {
        _vm.submenu = $$v
      },
      expression: "submenu"
    }
  }, [_c('v-list-tile-title', {
    staticClass: "has-sub-menu",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('label', [_vm._v("Add to Playlist")])]), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
    key: "add_to_playlist",
    staticClass: "default-menu-item track-menu-item",
    nativeOn: {
      "click": function($event) {
        _vm.addToNewPlaylist()
      }
    }
  }, [_c('v-list-tile-title', [_c('label', [_vm._v("New Playlist")])])], 1), _vm._v(" "), _vm._l((_vm.playlists), function(list, list_index) {
    return _c('v-list-tile', {
      key: ("playlist_2_" + list_index),
      staticClass: "default-menu-item track-menu-item",
      nativeOn: {
        "click": function($event) {
          _vm.addToPlaylist(list)
        }
      }
    }, [_c('v-list-tile-title', [_c('label', [_vm._v(_vm._s(list.name))])])], 1)
  })], 2)], 1)], 1) : _vm._e(), _vm._v(" "), (
    ['admin', 'moderator'].indexOf(_vm.currentUser.user_type) >
    -1 && !_vm.item.recommended
  ) ? _c('v-list-tile', {
    key: "recommended",
    staticClass: "default-menu-item track-menu-item",
    on: {
      "click": function($event) {
        (_vm.showFeatureModal = true) && (_vm.menu = false)
      }
    }
  }, [_c('v-list-tile-title', [_c('div', {
    staticClass: "menu-list-item dflex align-center px-2"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/star 1.svg"),
      "width": "16"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "ml-0"
  }, [_vm._v("Feature")])])])], 1) : _vm._e(), _vm._v(" "), (
    ['admin', 'moderator'].indexOf(_vm.currentUser.user_type) >
    -1 && _vm.item.recommended
  ) ? _c('v-list-tile', {
    key: "unrecommended",
    staticClass: "default-menu-item track-menu-item",
    nativeOn: {
      "click": function($event) {
        _vm.unrecommendAlbum()
      }
    }
  }, [_c('v-list-tile-title', [_c('div', {
    staticClass: "menu-list-item dflex align-center px-2"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/star 1.svg"),
      "width": "16"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "ml-0"
  }, [_vm._v("Unfeature")])])])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
    staticClass: "default-menu-item track-menu-item"
  }, [_c('v-list-tile-title', [_c('div', {
    staticClass: "menu-list-item dflex align-center px-2"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/pencil 1.svg"),
      "width": "16"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "ml-0"
  }, [_vm._v("Edit feature")])])])], 1), _vm._v(" "), _c('v-list-tile', {
    staticClass: "default-menu-item track-menu-item"
  }, [_c('v-list-tile-title', [_c('div', {
    staticClass: "menu-list-item dflex align-center px-2"
  }, [_c('img', {
    staticClass: "filter-invert",
    attrs: {
      "src": require("../assets/plus.svg"),
      "width": "16"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "ml-0"
  }, [_vm._v("Add to collection")])])])], 1), _vm._v(" "), _c('v-list-tile', {
    staticClass: "default-menu-item track-menu-item"
  }, [_c('v-list-tile-title', [_c('div', {
    staticClass: "menu-list-item dflex align-center px-2"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/playlist.svg"),
      "width": "16"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "ml-0"
  }, [_vm._v("Add to playlist")])])])], 1), _vm._v(" "), _c('v-list-tile', {
    key: "share",
    staticClass: "default-menu-item track-menu-item",
    nativeOn: {
      "click": function($event) {
        _vm.showShareDialog()
      }
    }
  }, [_c('v-list-tile-title', [_c('div', {
    staticClass: "menu-list-item dflex align-center px-2"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/respond-arrow 2.svg"),
      "width": "16"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "ml-0"
  }, [_vm._v("Share")])])])], 1), _vm._v(" "), (_vm.item.user.id != _vm.currentUser.id) ? _c('v-list-tile', {
    key: "hide",
    staticClass: "default-menu-item track-menu-item",
    nativeOn: {
      "click": function($event) {
        _vm.showHideAlbumDialog()
      }
    }
  }, [_c('v-list-tile-title', [_c('div', {
    staticClass: "menu-list-item dflex align-center px-2"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/b-eye 1.svg"),
      "width": "16"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "ml-0"
  }, [_vm._v("Hide")])])])], 1) : _vm._e(), _vm._v(" "), (_vm.item.user.id != _vm.currentUser.id) ? _c('v-list-tile', {
    key: "report",
    staticClass: "default-menu-item track-menu-item",
    nativeOn: {
      "click": function($event) {
        _vm.openReportDialog()
      }
    }
  }, [_c('v-list-tile-title', [_c('div', {
    staticClass: "menu-list-item dflex align-center px-2"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/o-warning 1.svg"),
      "width": "16"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "ml-0"
  }, [_vm._v("Report")])])])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
    key: "remove",
    staticClass: "default-menu-item track-menu-item",
    nativeOn: {
      "click": function($event) {
        _vm.openRemoveFromCollectionModal()
      }
    }
  }, [_c('v-list-tile-title', [_c('div', {
    staticClass: "menu-list-item dflex align-center px-2"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/o-warning 1.svg"),
      "width": "16"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "ml-0"
  }, [_vm._v("Remove")])])])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.hideTrackLength) ? _c('p', {
    staticClass: "track-count"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.item.tracks.length) + " " + _vm._s(_vm.item.tracks.length > 1 ? 'tracks' : 'track') + "\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.showHoverTrackInfo) ? _c('div', {
    staticClass: "track-hover-info"
  }, [_c('div', {
    staticClass: "item-name"
  }, [_vm._v(_vm._s(_vm.item.name))]), _vm._v(" "), _c('div', {
    staticClass: "artist-name"
  }, [_vm._v(_vm._s(_vm.owner.username))])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.forCollection) ? _c('v-flex', {
    staticClass: "track-actions",
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.gotoItem()
      }
    }
  }, [_c('v-flex', {
    staticClass: "touch-flex",
    attrs: {
      "xs12": "",
      "ripple": false
    },
    on: {
      "contextmenu": _vm.showTrackMenu
    }
  })], 1), _vm._v(" "), (!_vm.isPlaying || _vm.$store.state.player.isPaused) ? _c('v-btn', {
    staticClass: "play-button-main",
    class: {
      'play-button-2': _vm.playButton2
    },
    nativeOn: {
      "click": function($event) {
        _vm.playSong()
      }
    }
  }, [_c('v-icon', {
    class: [{
      'play-button-2': _vm.playButton2,
      iconHasWhiteBG: _vm.playButton2IconHasWhiteBG,
      'black--text': _vm.playButton2IconHasWhiteBG,
    }]
  }, [_vm._v("\n\t\t\t\t\t\t\tplay_arrow\n\t\t\t\t\t\t")])], 1) : _vm._e(), _vm._v(" "), (_vm.isPlaying && !_vm.$store.state.player.isPaused) ? _c('v-btn', {
    staticClass: "play-button-main",
    nativeOn: {
      "click": function($event) {
        _vm.pauseSong()
      }
    }
  }, [_c('v-icon', {
    class: [{
      'play-button-2': _vm.playButton2,
      iconHasWhiteBG: _vm.playButton2IconHasWhiteBG,
      'black--text': _vm.playButton2IconHasWhiteBG,
    } ]
  }, [_vm._v("\n\t\t\t\t\t\t\tpause\n\t\t\t\t\t\t")])], 1) : _vm._e(), _vm._v(" "), (_vm.currentUser && _vm.willMenuRender && !_vm.hideMoreMenu) ? _c('v-menu', {
    staticClass: "track-menu",
    attrs: {
      "position-x": _vm.x,
      "position-y": _vm.y,
      "absolute": "",
      "offset-y": "",
      "close-on-content-click": false,
      "nudge-width": 100
    },
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_c('v-card', {
    staticClass: "track-menu-options"
  }, [_c('v-list', [(_vm.currentUser.user_type == 'label') ? _c('v-list-tile', {
    key: "add_to_my_label",
    staticClass: "default-menu-item track-menu-item",
    nativeOn: {
      "click": function($event) {
        _vm.addToMyLabel()
      }
    }
  }, [_c('v-list-tile-title', [_c('label', [_vm._v("Add to my label")])])], 1) : _vm._e(), _vm._v(" "), (false && _vm.item.album_type != 'playlist') ? _c('v-list-tile', {
    key: "add_to_playlist",
    staticClass: "default-menu-item track-menu-item has-sub-menu"
  }, [_c('v-menu', {
    staticClass: "track-menu",
    attrs: {
      "offset-x": ""
    },
    model: {
      value: (_vm.submenu),
      callback: function($$v) {
        _vm.submenu = $$v
      },
      expression: "submenu"
    }
  }, [_c('v-list-tile-title', {
    staticClass: "has-sub-menu",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('label', [_vm._v("Add to Playlist")])]), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
    key: "add_to_playlist",
    staticClass: "default-menu-item track-menu-item",
    nativeOn: {
      "click": function($event) {
        _vm.addToNewPlaylist()
      }
    }
  }, [_c('v-list-tile-title', [_c('label', [_vm._v("New Playlist")])])], 1), _vm._v(" "), _vm._l((_vm.playlists), function(list, list_index) {
    return _c('v-list-tile', {
      key: ("playlist_2_" + list_index),
      staticClass: "default-menu-item track-menu-item",
      nativeOn: {
        "click": function($event) {
          _vm.addToPlaylist(list)
        }
      }
    }, [_c('v-list-tile-title', [_c('label', [_vm._v(_vm._s(list.name))])])], 1)
  })], 2)], 1)], 1) : _vm._e(), _vm._v(" "), (['admin', 'moderator'].indexOf(_vm.currentUser.user_type) > -1) ? _c('v-list-tile', {
    staticClass: "default-menu-item track-menu-item",
    on: {
      "click": function($event) {
        (_vm.showFeatureModal = true) && (_vm.menu = false)
      }
    }
  }, [_c('v-list-tile-title', [_c('div', {
    staticClass: "menu-list-item dflex align-center px-2"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/pencil 1.svg"),
      "width": "16"
    }
  }), _vm._v(" "), (_vm.item.web_title || _vm.item.web_review || _vm.item.mobile_title || _vm.item.mobile_review) ? _c('label', {
    staticClass: "ml-0"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tEdit Feature\n\t\t\t\t\t\t\t\t")]) : _c('label', {
    staticClass: "ml-0"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tFeature\n\t\t\t\t\t\t\t\t")])])])], 1) : _vm._e(), _vm._v(" "), (
    ['admin', 'moderator'].indexOf(_vm.currentUser.user_type) >
    -1 && _vm.item.recommended
  ) ? _c('v-list-tile', {
    key: "unrecommended",
    staticClass: "default-menu-item track-menu-item",
    nativeOn: {
      "click": function($event) {
        _vm.unrecommendAlbum()
      }
    }
  }, [_c('v-list-tile-title', [_c('div', {
    staticClass: "menu-list-item dflex align-center px-2"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/star 1.svg"),
      "width": "16"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "ml-0"
  }, [_vm._v("Unfeature")])])])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
    staticClass: "default-menu-item track-menu-item",
    nativeOn: {
      "click": function($event) {
        _vm.addToCollection(_vm.item)
      }
    }
  }, [_c('v-list-tile-title', [_c('div', {
    staticClass: "menu-list-item dflex align-center px-2"
  }, [_c('img', {
    staticClass: "filter-invert",
    attrs: {
      "src": require("../assets/plus.svg"),
      "width": "16"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "ml-0"
  }, [_vm._v("Add to collection")])])])], 1), _vm._v(" "), _c('v-list-tile', {
    staticClass: "default-menu-item track-menu-item"
  }, [_c('v-list-tile-title', [_c('div', {
    staticClass: "menu-list-item dflex align-center px-2"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/playlist.svg"),
      "width": "16"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "ml-0"
  }, [_vm._v("Add to playlist")])])])], 1), _vm._v(" "), _c('v-list-tile', {
    key: "share",
    staticClass: "default-menu-item track-menu-item",
    nativeOn: {
      "click": function($event) {
        _vm.showShareDialog()
      }
    }
  }, [_c('v-list-tile-title', [_c('div', {
    staticClass: "menu-list-item dflex align-center px-2"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/respond-arrow 2.svg"),
      "width": "16"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "ml-0"
  }, [_vm._v("Share")])])])], 1), _vm._v(" "), (_vm.item.user.id != _vm.currentUser.id) ? _c('v-list-tile', {
    key: "hide",
    staticClass: "default-menu-item track-menu-item",
    nativeOn: {
      "click": function($event) {
        _vm.showHideAlbumDialog()
      }
    }
  }, [_c('v-list-tile-title', [_c('div', {
    staticClass: "menu-list-item dflex align-center px-2"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/b-eye 1.svg"),
      "width": "16"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "ml-0"
  }, [_vm._v("Hide")])])])], 1) : _vm._e(), _vm._v(" "), (_vm.item.user.id != _vm.currentUser.id) ? _c('v-list-tile', {
    key: "report",
    staticClass: "default-menu-item track-menu-item",
    nativeOn: {
      "click": function($event) {
        _vm.openReportDialog()
      }
    }
  }, [_c('v-list-tile-title', [_c('div', {
    staticClass: "menu-list-item dflex align-center px-2"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/o-warning 1.svg"),
      "width": "16"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "ml-0"
  }, [_vm._v("Report")])])])], 1) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.hideTrackLength) ? _c('p', {
    staticClass: "track-count"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.item.tracks.length) + " " + _vm._s(_vm.item.tracks.length > 1 ? 'tracks' : 'track') + "\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.showHoverTrackInfo) ? _c('div', {
    staticClass: "track-hover-info"
  }, [_c('div', {
    staticClass: "item-name"
  }, [_vm._v(_vm._s(_vm.item.name))]), _vm._v(" "), _c('div', {
    staticClass: "artist-name"
  }, [_vm._v(_vm._s(_vm.owner.username))])]) : _vm._e()], 1) : _vm._e()], 2), _vm._v(" "), _c('v-flex', {
    staticClass: "track-detail",
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, [_c('p', {
    staticClass: "track-name"
  }, [_c('router-link', {
    attrs: {
      "to": ("/" + (_vm.item.album_type) + "/" + (_vm.item.slug))
    }
  }, [_vm._v(_vm._s(_vm.forCollection ? _vm.item.track.name : _vm.item.name))])], 1), _vm._v(" "), _c('p', {
    staticClass: "track-user-name"
  }, [(_vm.item.collaborators_count == 0) ? _c('router-link', {
    attrs: {
      "to": '/' + _vm.owner.slug
    }
  }, [_vm._v(_vm._s(_vm.owner.username))]) : (_vm.item.collaborators_count == 1) ? [_c('router-link', {
    attrs: {
      "to": '/' + _vm.owner.slug
    }
  }, [_vm._v(_vm._s(_vm.owner.username))]), _vm._v(", \n\t\t\t\t\t\t"), (_vm.item.collaborators && _vm.item.collaborators[0]) ? _c('router-link', {
    attrs: {
      "to": '/' + _vm.item.collaborators[0].user.slug
    }
  }, [_vm._v(_vm._s(_vm.item.collaborators[0].user.username))]) : _vm._e()] : _c('router-link', {
    attrs: {
      "to": ("/" + (_vm.item.album_type) + "/" + (_vm.item.slug))
    }
  }, [_vm._v(" " + _vm._s(_vm.forCollection ? _vm.item.name + ' • Album Name' : _vm.item.track.name))])], 2)]), _vm._v(" "), _c('v-flex', {
    staticClass: "dflex align-top"
  }, [_c('div', {
    staticClass: "track-time pr-3 font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.totalTime()) + " ")])]), _vm._v(" "), (_vm.forCollection || _vm.playlistId) ? _c('v-menu', {
    staticClass: "track-menu",
    attrs: {
      "offset-y": "",
      "close-on-content-click": false,
      "nudge-width": 100
    }
  }, [_c('v-btn', {
    staticClass: "toolbar-btn",
    attrs: {
      "slot": "activator",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.is_menu_hover = true
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("more_horiz")])], 1), _vm._v(" "), _c('v-card', [_c('v-list', [_c('v-list-tile', {
    key: "remove",
    staticClass: "default-menu-item track-menu-item",
    nativeOn: {
      "click": function($event) {
        _vm.openRemoveFromCollectionModal()
      }
    }
  }, [_c('v-list-tile-title', [_c('div', {
    staticClass: "menu-list-item dflex align-center"
  }, [_c('label', {
    staticClass: "ml-0 black--text"
  }, [_vm._v("Remove")])])])], 1)], 1)], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "feature-modal"
    },
    model: {
      value: (_vm.showFeatureModal),
      callback: function($$v) {
        _vm.showFeatureModal = $$v
      },
      expression: "showFeatureModal"
    }
  }, [_c('featureModal', {
    attrs: {
      "album": _vm.item
    }
  })], 1), _vm._v(" "), (_vm.showDownloadModal) ? _c('download-modal', {
    attrs: {
      "item": _vm.item,
      "dismiss": _vm.dismissDownloadDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showShareModal) ? _c('share-modal', {
    attrs: {
      "item": _vm.item,
      "dismiss": _vm.dismissShareDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_report_dialog) ? _c('v-dialog', {
    attrs: {
      "width": "1000",
      "persistent": ""
    },
    model: {
      value: (_vm.show_report_dialog),
      callback: function($$v) {
        _vm.show_report_dialog = $$v
      },
      expression: "show_report_dialog"
    }
  }, [_c('album-report-dialog', {
    attrs: {
      "album": _vm.item,
      "dismiss": _vm.closeReportDialog
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.hide_dialog) ? _c('v-dialog', {
    attrs: {
      "content-class": "my-dialog-1"
    },
    model: {
      value: (_vm.hide_dialog),
      callback: function($$v) {
        _vm.hide_dialog = $$v
      },
      expression: "hide_dialog"
    }
  }, [_c('v-card', [_c('v-card-media', {
    attrs: {
      "src": _vm.item.cover.url,
      "height": "125px",
      "contain": ""
    }
  }), _vm._v(" "), _c('v-card-text', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("\n\t\t\t\t\t\tAre you sure you want to hide this " + _vm._s(_vm.item.album_type) + "?\n\t\t\t\t\t")]), _vm._v(" "), _c('div', [_vm._v("\n\t\t\t\t\t\tYou won't be able to see it anymore, unless you visit the artists\n\t\t\t\t\t\tprofile or download the song.\n\t\t\t\t\t")])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "dark": "",
      "color": "grey"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hide_dialog = false
      }
    }
  }, [_vm._v("No, cancel please!")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "color": "red"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hideAlbum()
      }
    }
  }, [_vm._v("Yes, hide it!")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.playlist_dialog) ? _c('v-dialog', {
    staticClass: "playlist-dialog",
    attrs: {
      "max-width": "500px"
    },
    model: {
      value: (_vm.playlist_dialog),
      callback: function($$v) {
        _vm.playlist_dialog = $$v
      },
      expression: "playlist_dialog"
    }
  }, [_c('v-card', {
    staticClass: "playlist-dialog-body"
  }, [_c('v-card-title', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('h5', {
    staticClass: "ma-0"
  }, [_vm._v("New Playlist")])]), _vm._v(" "), _c('v-btn', {
    staticClass: "dialog-close-btn",
    nativeOn: {
      "click": function($event) {
        _vm.playlist_dialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("highlight_off")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "create-playlist-section"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "form-group": ""
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Name"), _c('label', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.playlist.name),
      expression: "playlist.name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.playlist.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.playlist, "name", $event.target.value.trim())
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "form-group": "",
      "text-xs-center": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "dark": "",
      "round": "",
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        _vm.createPlaylist()
      }
    }
  }, [_vm._v("Create Playlist")])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.forCollection) ? _c('v-dialog', {
    attrs: {
      "content-class": "invite-dialog",
      "width": "440"
    },
    model: {
      value: (_vm.show_remove_from_collection_modal),
      callback: function($$v) {
        _vm.show_remove_from_collection_modal = $$v
      },
      expression: "show_remove_from_collection_modal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n          Remove from Collection\n        ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n          Are you sure you want to remove this music from collection?\n        ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "dark": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.removeFromCollection()
      }
    }
  }, [_vm._v("\n            Yes\n          ")])], 1)], 1)], 1) : (_vm.playlistId) ? _c('v-dialog', {
    attrs: {
      "content-class": "invite-dialog",
      "width": "440"
    },
    model: {
      value: (_vm.show_remove_from_collection_modal),
      callback: function($$v) {
        _vm.show_remove_from_collection_modal = $$v
      },
      expression: "show_remove_from_collection_modal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n          Remove from Playlist\n        ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n          Are you sure you want to remove this track from playlist?\n        ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "black",
      "dark": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.removeFromPlaylist('track', _vm.item.track.id, _vm.playlistId);
        _vm.show_remove_from_collection_modal = false
      }
    }
  }, [_vm._v("\n            Yes\n          ")])], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e5d42cc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/trackcard.vue
// module id = 1640
// module chunks = 180